import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StatusBag, TypeBagsWeight } from '@app/enums';
import { Passenger } from '@app/models/micro';
import { GlobalsService } from '@app/services/micro/globals.service';
import { truncateText } from '@app/utils';

type TypeSize = 'xl' | 'lg' | 'md' | 'sm';
@Component({
  selector: 'am-bags-counter',
  templateUrl: './am-bags-counter.component.html',
  styleUrls: ['./am-bags-counter.component.scss'],
  standalone: false,
})
export class AmBagsCounterComponent implements OnInit {
  @Input() passenger: Passenger;
  @Input() size: TypeSize = 'xl';
  @Input() totalBags: number = 0;
  @Output() plus: EventEmitter<any> = new EventEmitter<any>();
  @Output() minus: EventEmitter<any> = new EventEmitter<any>();
  @Output() bagsChanged = new EventEmitter<void>();
  @Output() onRedeemAncillaries: EventEmitter<any> = new EventEmitter<any>();
  /** Cuando true, el onPlus no incrementa el contador sino que delega al padre */
  @Input() blockPlus = false;
  @Output() onBlockedPlus: EventEmitter<any> = new EventEmitter<any>();
  /** Cuando cambia, sincroniza totalBags con el valor real del passenger */
  @Input() set syncTrigger(value: number) {
    if (value > 0) {
      this.totalBags = this.passenger?.bags25KgAnd32kg ?? this.totalBags;
    }
  }

  currencyCode: string;
  limitBags: number = 0;

  // Bags per Passenger
  totalBagsToPay: number = 0;
  totalCostBagsPax: number = 0;

  constructor(private _globalService: GlobalsService) {}

  ngOnInit() {
    const reservation = this._globalService.getReservation();
    this.limitBags = this.passenger.getLimitBags(reservation.flightSummary?.isDomestic);
    this.bagsAutoSelection();
    this.initializeBagCounter();
  }

  /**
   * CI-19510: Inicializa el contador de maletas según las maletas incluidas del pasajero
   * Si tiene maletas incluidas, el contador inicia en ese número
   * Si no tiene maletas incluidas, el contador inicia en 0
   */
  initializeBagCounter() {
    const includedBags = this.passenger.includedBagsCount || 0;
    const paidBags = this.passenger.bagStack.filter(
      (b) => (b.status === StatusBag.TO_PAY || b.status === StatusBag.PAID || b.status === StatusBag.REDEEMED_APPLIED) && !b.used
    ).length;

    // El total de maletas es la suma de incluidas + pagadas
    this.totalBags = includedBags + paidBags;
  }

  get showCopyBagsIncluded() {
    // CI-19510: Mostrar "Maleta incluida" solo cuando todas las maletas seleccionadas son incluidas
    const selecteBagsIncluded =
      this.passenger.bagStack.filter((b) => b.status == StatusBag.INCLUDE && b.selected && !b.used)
        ?.length || 0;
    const totalSelectedBags = this.passenger.getSeletedBags()?.length || 0;
    const hasIncludedBags = selecteBagsIncluded > 0;
    const allIncludedBagsSelected = selecteBagsIncluded === totalSelectedBags;

    return hasIncludedBags && allIncludedBagsSelected;
  }

  get bagsRedempted() {
    return this.passenger.hasRedeemed && !this.passenger.hasBagsUsed25kg;
  }

  get bagsPendingRedemp() {
    return this.passenger.hasRedeeme;
  }

  get bagsToPayPax() {
    const bags = this.passenger.bagStack.filter(
      (b) => b.status == StatusBag.TO_PAY && b.selected && !b.used
    );
    this.totalBagsToPay = bags.length;
    this.currencyCode = bags[0]?.currency?.currencyCode || 'MXN';
    this.totalCostBagsPax = bags.reduce((total, bag) => total + (bag.currency?.total || 0), 0);

    return bags.length > 0;
  }

  get isNextBagUnavailable(): boolean {
    return this.passenger?.isNextBagUnavailable || false;
  }

  bagsAutoSelection() {
    const statusBag = [StatusBag.PAID, StatusBag.INCLUDE, StatusBag.REDEEMED_APPLIED];
    this.passenger.bagStack.map((bag) => {
      if (!bag.used && statusBag.includes(bag.status)) {
        bag.selected = true;
      }
    });
    this._globalService.setPassenger(this.passenger);
  }

  onPlus() {
    if (this.blockPlus) {
      this.onBlockedPlus.emit(this.totalBags + 1);
      return;
    }

    if (this.isNextBagUnavailable) {
      return;
    }
    if (this.totalBags < this.limitBags) {
      this.totalBags += 1;
    }
    this.plus.emit(this.totalBags);
    this.bagsChanged.emit();
  }

  onMinus() {
    if (this.totalBags > 0) {
      this.totalBags -= 1;
    }
    this.minus.emit(this.totalBags);
    this.bagsChanged.emit();
  }

  activeBenefit(element: any) {
    // En conexión, bloquear redención y mostrar modal
    if (this.blockPlus) {
      element.target.checked = false;
      this.passenger.switchRedeem = false;
      this.onBlockedPlus.emit();
      return;
    }
    if (element?.target?.checked) {
      this.passenger.switchRedeem = true;
      this.onRedeemAncillaries.next(true);
    }
  }

  handleModalRedeem() {
    // console.log('Abre modal de Beneficio Redencion');
  }

  truncateTextUi(elementTXt, maxLength = '18') {
    return truncateText(elementTXt, maxLength);
  }
}
